import { DateTime } from 'luxon';
import { UpdateAssigneeDto } from '../../commonTypes/project.types';

export const EFFECTIVE_FROM_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export function getUtcTodayYmd(): string {
    return DateTime.utc().toFormat('yyyy-MM-dd');
}

export type EffectiveFromApiResult = string | undefined | 'INVALID_FUTURE';

/**
 * Maps optional picker date to API effectiveFrom.
 * @param maxYmdUtc typically {@link getUtcTodayYmd}; selection must be <= max lexicographically.
 */
export function effectiveFromDateToApiString(date: Date | null | undefined, maxYmdUtc: string): EffectiveFromApiResult {
    if (!date || isNaN(date.getTime())) {
        return undefined;
    }
    const ymd = DateTime.fromJSDate(date, { zone: 'local' }).toFormat('yyyy-MM-dd');
    if (!EFFECTIVE_FROM_DATE_PATTERN.test(ymd)) {
        return undefined;
    }
    if (ymd > maxYmdUtc) {
        return 'INVALID_FUTURE';
    }
    return ymd;
}

export function buildUpdateAssigneeBody(
    base: Pick<UpdateAssigneeDto, 'rate' | 'rateType' | 'billable' | 'employmentType'>,
    effectiveFrom?: string
): UpdateAssigneeDto {
    return effectiveFrom ? { ...base, effectiveFrom } : { ...base };
}
